import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { Link } from "react-router-dom";
import { FETCH_FORECAST_CATEGORIES } from "./graphql";

const IndexPage = () => {
  const { loading, error, data } = useQuery(FETCH_FORECAST_CATEGORIES);
  const categories = data?.forecastCategories || [];

  const renderCategorySubmissionTimes = (mode) => {
    const modeCategories = categories.filter(
      (category) => category.mode === mode,
    );
    if (modeCategories.length === 0) {
      return <div className="text-xs opacity-60">No forecast categories.</div>;
    }

    return (
      <div className="mt-3 space-y-1 text-xs">
        {modeCategories.map((category) => {
          const categoryLabel = category.displayName;
          const submittedAt = category.lastSubmission?.submittedAt;
          return (
            <div key={category.id} className="flex justify-between space-x-4">
              <span>
                {categoryLabel} -{" "}
                {submittedAt
                  ? `submitted at ${new Date(submittedAt).toLocaleString()}`
                  : "Not submitted yet"}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <Page testing title="Sales Forecast">
      <div className="p-6 grid grid-cols-3 gap-6">
        <div className="card">
          <Link to="AB">
            <h5>Waboba AB</h5>
          </Link>
          <div className="mt-2">
            View sales forecast for Waboba AB. Manage forecast categories.
            Connect to Odoo customers and warehouses to automatically fetch
            history data.
          </div>
          {renderCategorySubmissionTimes("AB")}
        </div>

        <div className="card">
          <Link to="INC">
            <h5>Waboba INC</h5>
          </Link>
          <div className="mt-2">
            View sales forecast for Waboba INC. Import forecast data from the
            FCST Sheet.
          </div>
          {renderCategorySubmissionTimes("INC")}
        </div>

        <div className="card">
          <Link to="ALL">
            <h5>Waboba AB + INC</h5>
          </Link>
          <div className="mt-2">
            View the combined forecast for both Waboba AB and Waboba INC.
          </div>
        </div>
      </div>
    </Page>
  );
};

export default IndexPage;
